<template>
  <div class="ac-wrap" id="forget">
    <!-- 验证手机号码 -->
    <div class="ac-con" v-if="status==0">
      <div class="ac-con-lt">
        <div class="ac-general">手机号</div>
        <div class="ac-general">短信验证码</div>
      </div>
      <div class="ac-con-ct">
        <div class="ac-general">
          <input type="text" name="" v-model="phoneNum" @keyup.down="changeFocus(1)" @keyup.up="changeFocus(1)" @keyup.enter="smsVerify"
            placeholder="请输入手机号">
        </div>
        <div class="ac-general">
          <input type="text" style="width: 160px;float:left" name="" @keyup.down="changeFocus(0)" @keyup.up="changeFocus(0)" @keyup.enter="smsVerify"
            v-model="smscode" placeholder="请输入验证码">
          <span :class="['ac-verify', 'ac-send',{'active':smsStatu}]" @click="isSendSms">{{smsCon}}</span>
        </div>

        <div class="ac-general">
          <div class="ac-btn" @click="smsVerify">下一步</div>
        </div>
      </div>
      <div class="ac-con-rt">
        <div class="ac-general">
          <p class="ac-con-msg" v-if="phoneState.type!=''">
            <ep-alert :type="phoneState.type">{{phoneState.msg}}</ep-alert>
          </p>
        </div>
        <div class="ac-general">
          <p class="ac-con-msg" v-if="smsState.type!=''">
            <ep-alert :type="smsState.type">{{smsState.msg}}</ep-alert>
          </p>
        </div>
      </div>
    </div>

    <!-- 重置密码 -->
    <div class="ac-con" v-if="status==1">
      <div class="ac-con-lt">
        <div class="ac-general">新密码</div>
        <div class="ac-general">确认密码</div>
      </div>
      <div class="ac-con-ct">
        <div class="ac-general">
          <input type="password" name="" @keyup.down="changeFocus(1)" @keyup.up="changeFocus(1)" @keyup.enter="setPassword" v-model="pwd"
            @focus="pwdStatu={type: '',msg: ''};confirmStatu={type: '',msg: ''};pwdState=true" @blur="pwdState=false" placeholder="请输入密码">
        </div>
        <div class="ac-general">
          <input type="password" @keyup.down="changeFocus(1)" @keyup.up="changeFocus(1)" @keyup.enter="setPassword" name="" v-model="confirm"
            placeholder="请再次输入密码">
        </div>
        <div class="ac-general">
          <div class="ac-btn" @click="setPassword">提交</div>
        </div>
      </div>
      <div class="ac-con-rt">
        <div class="ac-general">
          <p class="message-tip" v-if="pwdShowTip">
            密码长度为8-20个字符，且至少包含1个大写字母，1个小写字母和1个数字
          </p>
          <p class="ac-con-msg" v-if="pwdStatu.type!=''">
            <ep-alert :type="pwdStatu.type">{{pwdStatu.msg}}</ep-alert>
          </p>
        </div>
        <div class="ac-general">
          <p class="ac-con-msg" v-if="confirmStatu.type!=''">
            <ep-alert :type="confirmStatu.type">{{confirmStatu.msg}}</ep-alert>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import account from '../../data/ucenter/account.js'
  import captcha from '../../data/ucenter/captcha.js'

  export default {
    data() {
      return {
        // 操作状态
        status: 0,
        // 手机号码
        phoneNum: '',
        // 手机状态
        phoneState: {
          type: '',
          msg: ''
        },
        // 短信按钮状态
        smsStatu: true,
        // 短信状态
        smsState: {
          type: '',
          msg: ''
        },
        // 短信验证码
        smscode: '',
        // 短信验证码按钮
        smsCon: '发送信息',
        // 短信验证码默认时间
        smsTime: 60,
        // 输入密码
        pwd: '',
        // 密码校验
        pwdUrl: ['../../../static/img/1.png', '../../../static/img/1.png', '../../../static/img/1.png',
          '../../../static/img/1.png'
        ],
        pwdShowTip: false,
        // 校验框状态
        pwdState: false,
        // 密码状态
        pwdStatu: {
          type: '',
          msg: ''
        },
        // 再次输入密码
        confirm: '',
        // 再次输入状态
        confirmStatu: {
          type: '',
          msg: ''
        }
      }
    },
    mounted() {
      this.changeFocus(0)
    },
    watch: {
      // 实时校验用户名
      phoneNum() {
        let type = account.vertify_username(this.phoneNum).type
        if (type == 2) {
          this.smsStatu = false
        } else {
          this.smsStatu = true
        }
      },
      // 实时监听密码变动
      pwd() {
        this.formatPwd(this.pwd)
      }
    },
    methods: {
      // 短信验证
      smsVerify() {
        // 校验用户名格式
        let userState = account.vertify_username(this.phoneNum)
        let changePhoneState = (type, msg) => {
          this.phoneState.type = type
          this.phoneState.msg = msg
        }
        if (userState.type != 2) {
          changePhoneState('error', userState.msg)
          this.smsStatu = true
          return
        }
        // 校验用户是否存在
        (async() => {
          let userExit = await account.isexit_username(this.phoneNum)
          if (userExit) {
            changePhoneState('success', '手机号正确')
            this.smsStatu = false
            _vertify_smscode()
            return
          } else {
            changePhoneState('error', '手机号未注册')
            this.smsStatu = true
            return
          }
        })()
        let _vertify_smscode = () => {
          // 校验短信验证码格式
          let smsState = captcha.verity_six_code(this.smscode)
          let changeSmsState = (type, msg) => {
            this.smsState.type = type
            this.smsState.msg = msg
          }
          if (smsState.type != 2) {
            changeSmsState('error', smsState.msg)
            return
          }
          // 验证短信验证码是否正确
          (async() => {
            let smsCorrect = await captcha.correct_smscode(this.smscode)
            if (smsCorrect) {
              this.status = 1
              this.$emit('change', 1)
            } else {
              changeSmsState('error', '验证码错误');
                this.smscode = '';
              return
            }
          })()
        }
      },
      // 设置密码
      setPassword() {
        this.pwdState = false
        // 验证密码格式是否正确
        let pwdState = account.vertify_password(this.pwd)
        let changePwdState = (type, msg) => {
          this.pwdStatu.type = type
          this.pwdStatu.msg = msg
        }
        if (pwdState.type != 2) {
          changePwdState('error', pwdState.msg)
          return
        } else {
          changePwdState('success', pwdState.msg)
        }
        // 验证密码是否输入一致
        let pwdAccord = account.vertify_accord(this.pwd, this.confirm)
        let changeConfirmStatu = (type, msg) => {
          this.confirmStatu.type = type
          this.confirmStatu.msg = msg
        }
        if (pwdAccord.type != 2) {
          changeConfirmStatu('error', pwdAccord.msg)
          return
        } else {
          changeConfirmStatu('success', pwdAccord.msg)
        }
        // 重置密码
        (async() => {
          let isSuccess = account.rebackpasswd({
            username: this.phoneNum,
            smscode: this.smscode,
            newPassword: this.pwd
          })
          if (isSuccess) {
            this.$router.push('/login')
            this.$message.success('密码重置成功');
          } else {
            this.$message.error('密码重置失败，请重试');
          }
        })()
      },
      // 切换焦点
      changeFocus(num) {
        let allInput = document.getElementById('forget').getElementsByClassName('ac-con')[0].querySelectorAll('input')
        if (num < allInput.length && num > -1) {
          allInput[num].focus()
        }
      },
      // 是否开启短信验证
      isSendSms() {
        if (!this.smsStatu) {
          (async() => {
            let smsCodeState = await captcha.get_rebackpasswdsmscode({
              imgcode: this.imgcode,
              username: this.phoneNum
            })
            let changeSmsState = (type, msg) => {
              this.smsState.type = type
              this.smsState.msg = msg
            }
            if (smsCodeState) {
              changeSmsState('success', '发送成功')
            } else {
              changeSmsState('error', '发送失败')
            }
          })()
          this.sendSms()
        } else {
          return
        }
      },
      // 短信验证码
      sendSms() {
        if (this.smsTime < 0) {
          this.smsCon = '重新发送'
          this.smsStatu = false
          this.smsTime = 60
        } else {
          this.smsCon = `重新发送(${this.smsTime})`
          this.smsStatu = true
          setTimeout(() => {
            this.smsTime--
              this.sendSms()
          }, 1000)
        }
      },
      // 实时校验密码格式
      formatPwd(data) {
        let pwdState = account.vertify_password(data);
        this.pwdShowTip = pwdState.type != 2;
      },
    }
  }

</script>

<style lang="stylus" scoped>
  .ac-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .ac-con {
      width: 100%;
      height: 100%;
      position: relative;
      display: inline-flex;
      .ac-con-lt {
        width: 100px;
        height: 100%;
        margin-right: 30px;
        font-size: 16px;
        color: #666666;
        text-align: right;
      }
      .ac-con-ct {
        width: 340px;
        height: 100%;
        margin-right: 30px;
        text-align: left;
        .ac-btn {
          width: 100%;
          height: 100%;
          text-align: center;
          border-radius: 5px;
          background: #2db7f5;
          color: #fff;
          transition: all .3s ease-in-out;
          cursor: pointer;
          a {
            text-decoration: none;
            color: #fff;
          }
          &:hover {
            background: #57c5f7;
          }
        }
        .ac-verify {
          display: inline-block;
          height: 40px;
          width: 120px;
          border: 1px solid #DCDCDC;
          float: right;
        }
        .ac-send {
          text-align: center;
          color: #666;
          font-size: 14px;
          border-radius: 5px;
          cursor: pointer;
          &:hover {
            border: 1px solid #2ea9df;
            color: #2ea9df;
          }
        }
        .active {
          cursor: no-drop;
        }
      }
      .ac-con-rt {
        flex: 1;
        height: 100%;
        .ac-con-msg {
          display: block;
          height: 40px;
          width: 100%;
          line-height: 50px;
          text-align: left;
        }
        .message-tip{
          font-size: 14px;
          color: red;
         }
        .ac-check {
          height: 145px;
          width: 164px;
          background: url('../../../static/img/kuang.png') no-repeat center;
          box-sizing: border-box;
          padding: 10px;
          .ac-check-list {
            height: 30px;
            color: #666;
            font-size: 12px;
            text-align: left;
            text-indent: 10px;
            img {
              margin-right: 10px;
              /* vertical-align: middle; */
            }
          }
        }
      }
      .ac-general {
        width: 100%;
        height: 40px;
        margin-bottom: 30px;
        line-height: 40px;
      }
      input {
        width: 100%;
        height: 100%;
        border: 1px solid #c1c1c1;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 0 10px;
        &:focus {
          outline: none;
          box-shadow: 0 0 5px rgba(85, 190, 234, 1);
          border: 1px solid #55beec;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Forget.vue?66a0575f